import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { BuyButton } from './BuyButton';
export const ResultsSection: React.FC = () => {
  const results = ['Diferenciás mejor cada perfil clínico.', 'Entendés qué circuito mantiene el insomnio.', 'Intervenís distinto según predomine ansiedad o depresión.', 'Ordenás tus sesiones con más dirección y criterio.', 'Trabajás con más seguridad, estructura y precisión profesional.'];
  return <section className="py-16 bg-navy text-white px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-171">
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-172">
        <div className="absolute w-96 h-96 bg-lavender rounded-full blur-3xl -top-20 -left-20" data-id="element-173"></div>
        <div className="absolute w-96 h-96 bg-accent rounded-full blur-3xl -bottom-20 -right-20" data-id="element-174"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-175">
        <h2 className="font-serif text-3xl sm:text-4xl font-bold text-white mb-10 text-center" data-id="element-176">
          EL RESULTADO
        </h2>

        <div className="grid sm:grid-cols-2 gap-x-8 gap-y-4 mb-12" data-id="element-177">
          {results.map((result, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="flex items-start gap-3" data-id="element-178">
              <CheckCircle className="w-6 h-6 text-lavender shrink-0 mt-0.5" data-id="element-179" />
              <p className="text-gray-200 text-lg" data-id="element-180">{result}</p>
            </motion.div>)}
        </div>

        <div className="flex justify-center mt-12" data-id="element-181">
          <BuyButton data-id="element-182" />
        </div>
      </div>
    </section>;
};